<template>
  <div class="content">
    <h2 class="page-title">設定メニュー</h2>
    <div class="p-4 text-center">
      <md-button
        type="button"
        class="btn-lg btn-success base-btn col-md-9 mb-2 mb-md-3 m-0"
        :to="{ name: 'SettingEdit' }"
      >
        個人設定
      </md-button>
      <md-button
        type="button"
        class="btn-lg btn-success base-btn col-md-9 mb-2 mb-md-3 m-0"
        :to="{ name: 'SettingCreate' }"
      >
        新規アカウント作成
      </md-button>
      <md-button
        type="button"
        class="btn-lg btn-success base-btn col-md-9 m-0"
        :to="{ name: 'SettingCompanyIndex' }"
      >
        グループ設定
      </md-button>
    </div>
  </div>
</template>
<script>
import Mixin from '../mixin/Mixin'
export default {
  name: 'SettingIndex',
  components: {},
  mixins: [Mixin],
  data: () => ({}),
  methods: {},
  created() {
    this.setSettingMyData()
  },
}
</script>

<style lang="sass" scoped></style>



// WEBPACK FOOTER //
// src/components/setting/Index.vue